
          import $$Component from "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/popup/Register.vue?vue&type=script"
          
          import "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/popup/Register.vue?vue&type=style"
          
          import { render } from "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/popup/Register.vue?vue&type=template"
          export * from "/Users/devdog/Local Sites/tmsuper/app/public/wp-content/themes/_wp-tm-super/typescript/popup/Register.vue?vue&type=template"
          $$Component.render = render
          export default $$Component